import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { Rating } from '@/app/donation/_components/Rating';
import { ReviewDetailContent } from '@/app/donation/gifts/[productNumber]/_components/ReviewDetailContent';
import { Image } from '@/components/client';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { openResponsiveDialog } from '@/stores/DrawerStore';
interface WeeklyBestPhotoReviewListItemProps {
  reviewId: number;
  productThumbnailUrl: string;
  productName: string;
  rating: number;
  reviewContent: string;
}
export const WeeklyBestPhotoReviewListItem = t0 => {
  const $ = _c(35);
  const {
    reviewId,
    productThumbnailUrl,
    productName,
    rating,
    reviewContent
  } = t0;
  let t1;
  if ($[0] !== reviewId) {
    t1 = () => {
      openResponsiveDialog({
        component: ReviewDetailContent,
        modalHeader: "\uD3EC\uD1A0\uD6C4\uAE30",
        className: {
          modal: "max-w-[900px]"
        },
        props: {
          reviewId
        },
        drawerNoPadding: true
      });
    };
    $[0] = reviewId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleReviewClick = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("flex w-fit items-center gap-16 rounded-large bg-Gray-white p-16 shadow-base", "mobile-tablet:p-12");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `${productName} 후기 상세 보기`;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("relative size-104 overflow-hidden rounded-medium transition-opacity duration-200 hover:opacity-80", "mobile-tablet:size-72");
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = `${productName} 이미지`;
  let t6;
  if ($[4] !== productThumbnailUrl || $[5] !== t5) {
    t6 = <Image src={productThumbnailUrl} fill={true} alt={t5} sizes={`${BREAKPOINTS.MOBILE_TABLET} 72px, 104px`} className="object-cover" />;
    $[4] = productThumbnailUrl;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== handleReviewClick || $[8] !== t3 || $[9] !== t6) {
    t7 = <button type="button" onClick={handleReviewClick} aria-label={t3} className={t4}>{t6}</button>;
    $[7] = handleReviewClick;
    $[8] = t3;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("flex w-237 flex-col", "mobile-tablet:h-72 mobile-tablet:w-198 mobile-tablet:justify-center");
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== rating) {
    t9 = <Rating value={rating} size={12} />;
    $[12] = rating;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = `${productName} 후기 상세 보기`;
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = cn("line-clamp-1 py-2 font-600 text-Gray-900 transition-colors duration-200 typo-body4 hover:text-Gray-700", "mobile-tablet:font-600 mobile-tablet:typo-caption1");
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== productName) {
    t12 = <p className={t11}>{productName}</p>;
    $[15] = productName;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== handleReviewClick || $[18] !== t10 || $[19] !== t12) {
    t13 = <button type="button" aria-label={t10} onClick={handleReviewClick} className="text-start">{t12}</button>;
    $[17] = handleReviewClick;
    $[18] = t10;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = cn("pt-4 text-start font-400 text-Gray-600 transition-colors duration-200 typo-body4 hover:text-Gray-700", "mobile-tablet:pt-0 mobile-tablet:font-400 mobile-tablet:typo-caption1");
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  const t15 = `${productName} 후기 상세 보기`;
  let t16;
  if ($[22] !== reviewContent) {
    t16 = <span className="line-clamp-2 w-full text-left">{reviewContent}</span>;
    $[22] = reviewContent;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== handleReviewClick || $[25] !== t15 || $[26] !== t16) {
    t17 = <button type="button" onClick={handleReviewClick} className={t14} aria-label={t15}>{t16}</button>;
    $[24] = handleReviewClick;
    $[25] = t15;
    $[26] = t16;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t13 || $[29] !== t17 || $[30] !== t9) {
    t18 = <div className={t8}>{t9}{t13}{t17}</div>;
    $[28] = t13;
    $[29] = t17;
    $[30] = t9;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t18 || $[33] !== t7) {
    t19 = <li className={t2}>{t7}{t18}</li>;
    $[32] = t18;
    $[33] = t7;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  return t19;
};